module.exports = __webpack_public_path__ + "img/presion-1.227ffd58.svg";